export const tomiAI = {
  getGaId: () => {
    const { ga } = window;
    if (typeof ga !== 'undefined' && ga.getAll().length > 0) return ga.getAll()[0].get('clientId');
  },
};
